"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// With .autoProvideJquery() in webpack.config.js we'll need to declare jQuery globally here,
// otherwise it'll either fall flat on JS that is kept outside webpack (e.g. stuff inlined in templates) or for stuff inside webpack,
// Also, since jQuery isn't typed, we'll ignore that line (just that one!), to satisfy the linting.
// @ts-ignore
const $ = require("jquery");
// @ts-ignore
global.$ = global.jQuery = $;
// From here on include your JS modules:
require("glightbox/src/postcss/glightbox.css");
require("../scss/app.scss");
require("../scss/glightbox.scss");
require("./modules/navigation");
require("./modules/collapse");
require("./modules/StaffRequirements");
